import React, { useState, useEffect } from "react";
import InstallButton from "@/components/InstallButton";
import { canInstall, onInstallChange, isStandalone } from "@/lib/pwa";

export default function PwaInstall() {
  const [, setAvailable] = useState(canInstall());

  useEffect(() => onInstallChange(setAvailable), []);

  if (isStandalone()) return null;

  return (
    <div className="fixed bottom-5 left-5 z-[60]" data-testid="pwa-fab">
      <InstallButton
        label="Uygulamayı Ekle"
        className="inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-full px-5 py-3.5 text-sm shadow-2xl ring-4 ring-indigo-600/20 transition-colors animate-float-up"
      />
    </div>
  );
}
